import { useCopyNotif } from "../../stores/CopyNotifStore/CopyNotifStore";
import CopyNotif from "./CopyNotif";
import s from "./CopyNotifications.module.scss";

const CopyNotifications = () => {
  const { components, removeCopyComponent } = useCopyNotif();

  return (
    <div className={s.notifications}>
      {components.map((comp) => (
        <CopyNotif key={comp.id} id={comp.id} onRemove={removeCopyComponent} />
      ))}
    </div>
  );
};

export default CopyNotifications;
